/**
 * Affise, `/postbacks/affise`. Backoffice, TMA and the Telegram bot agree on
 * this template verbatim.
 */
export const affiseContract = {
    id: 'affise',
    displayName: 'Affise',
    route: 'affise',
    trackingTagMacro: '{visit_id}',
    amountBehavior: 'amount comes from {payout} on FTD/CPA/REDEP. currency is not an Affise macro; CPA hardcodes EUR.',
    duplicateParamPolicy: 'array-then-tolerant-last-wins',
    caseSensitiveParams: [],
    requiresFixedCurrencyForCpa: true,
    pitfalls: [],
    sourceRefs: [
        'apps/api/src/modules/postbacks/controllers/postbacks.controller.ts:145-178 (generic PostbackQueryDto)',
    ],
    events: [
        {
            event: 'REG',
            eventValue: 'registration',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{pid}' },
                { ourParam: 'tracking_tag', macro: '{visit_id}' },
            ],
        },
        {
            event: 'FTD',
            eventValue: 'ftd',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{pid}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'tracking_tag', macro: '{visit_id}' },
            ],
        },
        {
            event: 'QUALIFIED_CPA',
            eventValue: 'cpa',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{pid}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'currency', macro: 'EUR' },
                { ourParam: 'tracking_tag', macro: '{visit_id}' },
            ],
            fixedParams: { currency: 'EUR' },
        },
        {
            event: 'REDEP',
            eventValue: 'redep',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{pid}' },
                { ourParam: 'amount', macro: '{sum}' },
                { ourParam: 'tracking_tag', macro: '{visit_id}' },
            ],
        },
    ],
};
//# sourceMappingURL=affise.js.map